/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-03-09 16:30:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-01-16 10:23:34
 */

import React from "react";
import { HashRouter as Router } from "react-router-dom";
import { renderRoutes } from "assets/renderRouter";
import Loadable from "react-loadable"; //按需加载路由插件
import { Provider } from "react-redux";
import { store } from "../tools/store";

const MyLoadingComponent = (v: { isLoading: any; error: any }) => {
  if (v.isLoading) {
    return <div>Loading...</div>;
  } else if (v.error) {
    return <div>Sorry, there was a problem loading the page.</div>;
  } else {
    return null;
  }
};
const Landing = Loadable({
  loader: () => import("../views/landing"),
  loading: MyLoadingComponent,
});
const Order = Loadable({
  loader: () => import("../views/order"),
  loading: MyLoadingComponent,
});
const Model = Loadable({
  loader: () => import("../views/model"),
  loading: MyLoadingComponent,
});
const FaultType = Loadable({
  loader: () => import("../views/faultType"),
  loading: MyLoadingComponent,
});
const Shops = Loadable({
  loader: () => import("../views/shops"),
  loading: MyLoadingComponent,
});
//泰国寄售
const DeShops = Loadable({
  loader: () => import("./shops/delist"),
  loading: MyLoadingComponent,
});
const ShopDetails = Loadable({
  loader: () => import("../views/shopDetails"),
  loading: MyLoadingComponent,
});
const ReserSuccess = Loadable({
  loader: () => import("../views/reserSuccess"),
  loading: MyLoadingComponent,
});
const routes = [
  {
    path: "/landing", //落地页
    component: Landing,
  },
  {
    path: "/model", //选择机型
    component: Model,
  },
  {
    path: "/order", //新首页
    component: Order,
  },
  {
    path: "/faultType", //寄售错误类型页面
    component: FaultType,
  },
  {
    path: "/shops", //店铺列表
    component: Shops,
  },
  {
    path: "/deshops", //泰国店铺列表
    component: DeShops,
  },
  {
    path: "/shopDetails/:id", //店铺详情
    component: ShopDetails,
  },
  {
    path: "/reserSuccess", //下单成功页
    component: ReserSuccess,
  },
  {
    path: "/",
    redirect: "/landing",
  },
];

const mRoute = () => {
  return (
    <Provider store={store}>
      <Router>{renderRoutes(routes)}</Router>
    </Provider>
  );
};

export default mRoute;
